/* eslint-disable vars-on-top */
/* eslint-disable no-plusplus */
/* eslint-disable no-array-constructor */
/* eslint-disable camelcase */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import SendIcon from '@mui/icons-material/Send';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import TWLocale from 'date-fns/locale/zh-TW';
import datetimeobj from 'date-and-time';
// material
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  DialogContent,
  DialogActions,
  Grid,
  Tabs,
  Tab,
  Autocomplete,
  Paper,
  MenuItem,
  Checkbox,
  InputLabel,
  Stack,
  Box,
  TextField,
  styled,
  Typography,
  Divider,
  Container,
  Snackbar,
  FormControlLabel,
  Switch,
  CardMedia,
  FormControl
} from '@mui/material';

import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

import Select, { SelectChangeEvent } from '@mui/material/Select';

import MuiAlert from '@mui/material/Alert';
import addDays from 'date-fns/addDays';
import { DateRange } from 'react-date-range';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { zhTW } from '@mui/material/locale';
import { TileLayer, MapContainer, LayersControl, Marker, Popup, Tooltip } from 'react-leaflet';
// components
import Page from '../components/Page';

import EventDialog from '../components/_dashboard/DVR/eventDialog';
import BootpDialog from '../components/_dashboard/DVR/BootpDialog';
import TTable from '../components/TTable';

// 定義Switch外觀
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} checked={props.checked} onChange={props.onChange} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const maps = {
  base: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary,
}));
const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));
// 定義切換頁
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
const centergps = {
  彰化縣: [24.050666, 120.483982],
  雲林縣: [23.702376, 120.386782]
};
const hour = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23'
];
export default function mobileDVR() {
  const headCell = [
    {
      id: 'vehicle',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '車牌'
    },
    {
      id: 'date',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '發生日期'
    },
    {
      id: 'time',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '發生時間'
    },
    {
      id: 'event',
      numeric: false,
      disablePadding: false,
      fillter: true,
      label: '事件'
    }, {
      type: 'render',
      fn: (row) => {
        const { leonTagProductNumber, description, updateTime, enable } = row
        return (
          <Button variant="text" onClick={
            () => {
              eventButtonhandleClickOpen(row);
            }
          }>
            查看
          </Button>
        )
      }
    }
  ];
  // 宣告一個新的 state 變數，我們稱作為「count」。
  // 相似於 componentDidMount 和 componentDidUpdate:
  // eslint-disable-next-line prefer-const
  let raw_video1 = [];
  let raw_video2 = [];

  const Region = localStorage.getItem('region');
  const host = localStorage.getItem('apiurl');
  const [reason, setreason] = React.useState(' ');
  const [Datevalue, setDatevalue] = React.useState(new Date());
  const [eventDatevalue, seteventDatevalue] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: 'selection'
    }
  ]);
  const [Vehiclelist, setVehiclelist] = React.useState([]);
  // eslint-disable-next-line camelcase
  const [event_message, setevent_message] = React.useState([]);
  const [selecVehicleplate, setSselecVehicleplate] = useState(null);

  const [carno, setcarno] = React.useState('');
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [Buttonopen, setButtonopen] = React.useState(false);
  const [eventButtonopen, seteventButtonopen] = React.useState(false);
  const [hourobj, sethourobj] = React.useState('');
  const [videourl, setvideourl] = React.useState('');
  const [openmap, setopenmap] = useState(null);
  const [openmap1, setopenmap1] = useState(null);
  const [checked, setChecked] = React.useState([]);
  const [eventvideo, seteventvideo] = React.useState([]);
  const [eventcarobj, seteventcarobj] = React.useState({ vehicle: '', event_video_url: '', Latitude: 24.050666, Longitude: 120.483982 });
  const [licenseplatestr, setlicenseplatestr] = React.useState('');
  const [headCells, setHeadCells] = useState([]);
  const [autoreflash, setautoreflash] = useState(false);
  const [intervalId, setintervalId] = useState(0);
  const [WORKBTIME, setWORKBTIME] = React.useState(' ');
  const [WORKETIME, setWORKETIME] = React.useState(' ');

  const [rawvideodgopen, setrawvideodgopen] = React.useState(false);
  const rawvideolist = useRef([]);
  const rawDatevalue = useRef(new Date());
  const selectrawVehicleplate = useRef(null);
  const rawhourobj = useRef('');
  const [seleceventplate, setseleceventplate] = useState([]);
  const onTagsChange = (event, values) => {
    console.log(values);
    setseleceventplate(values);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    await setHeadCells(headCell);
    await getDVR_event_message();
    await Vehicle_management();
    // 定時讀取車機清單
    // eslint-disable-next-line no-const-assign
    // eslint-disable-next-line react-hooks/exhaustive-deps

    // componentWillUnmount
    return function cleanup() {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (autoreflash) {
      // 更新相機1
      let myintervalId = setInterval(get_raw_video, 10000);
      setintervalId(myintervalId);
    } else {
      clearInterval(intervalId);
    }
  }, [autoreflash, selecVehicleplate, hourobj, Datevalue]);

  // eslint-disable-next-line camelcase
  const getdriver_attendancebydate = async (CAR_NO) => {

    const datestr = dateToStrTime(rawDatevalue.current);
    await axios
      .get(`${host}api/driver/getdriver_attendancebydate?Region=${Region}&carno=${CAR_NO}&date=${datestr}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          setWORKBTIME(response.data.WORK_BTIME);
          setWORKETIME(response.data.WORK_ETIME);
        }

      }
      )
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  // 取得事件
  // eslint-disable-next-line camelcase
  const getDVR_event_message = async () => {
    await axios
      .get(`${host}api/DVR/getDVR_event_message`, {
        headers: {
          'content-type': 'application/json'
        }
      })
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          setevent_message(response.data.data);
        } else {
          setreason('讀取token失敗!!');
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };

  // eslint-disable-next-line camelcase
  const get_event_video_list = async () => {
    // eslint-disable-next-line eqeqeq
    const startDatevalue = dateTonetcoreStrTime(eventDatevalue[0].startDate, 0);
    // 結束日期加一天
    var newendDate = new Date(eventDatevalue[0].endDate);
    newendDate = new Date(newendDate.setDate(newendDate.getDate() + 1));
    const endDatevalue = dateTonetcoreStrTime(newendDate, 0);

    let Query = `starttime=${startDatevalue}&enttime=${endDatevalue}`;


    if (seleceventplate.length > 0) {
      let entplatestring = '';
      for (let eventplateindex = 0; eventplateindex < (seleceventplate.length - 1); eventplateindex++) {
        entplatestring += `${seleceventplate[eventplateindex].CAR_NO},`;
      }
      entplatestring += `${seleceventplate[seleceventplate.length - 1].CAR_NO}`;
      Query += `&vehicle=${entplatestring}`;
    }
    if (checked.length > 0) {
      const eventstring = checked.toString();
      Query += `&eventtype=${eventstring}`;
    }

    const url = `${host}api/DVR/getDVR_event?${Query}`;
    await axios
      .get(
        url,
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      )
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          let tempresults = [];
          response.data.data.forEach(element => {
            element.date = tabledateToStrTime(element.event_start_time, 0);
            element.time = tabledateToStrTime(element.event_start_time, 1);

            tempresults.push(element);
          });
          seteventvideo(tempresults);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });



  };
  // eslint-disable-next-line camelcase
  const click_raw_video_search = async () => {
    // 紀錄每個參數除非從新按下搜尋
    rawDatevalue.current = Datevalue;
    selectrawVehicleplate.current = selecVehicleplate;
    rawhourobj.current = hourobj;
    // 相機一相機二一起更新
    await get_raw_video();
    // 設定工時
    await getdriver_attendancebydate(selectrawVehicleplate.current.CAR_NO);
  }
  // eslint-disable-next-line camelcase
  const get_raw_video = async () => {
    // eslint-disable-next-line eqeqeq
    if (selectrawVehicleplate.current != null && rawhourobj.current != '') {
      const datestr = dateToStrTime(rawDatevalue.current);
      // 相機一
      await get_raw_video_api(datestr, 1);
      // 相機二
      await get_raw_video_api(datestr, 2);

      let temprawvideolist = [];
      // 二微陣列
      for (let raw_videoindex = 0; raw_videoindex < raw_video1.length; raw_videoindex++) {
        let newraw_videoobj = {};

        newraw_videoobj.video_datetime_tz = raw_video1[raw_videoindex].video_datetime_tz;
        newraw_videoobj.minutestring = raw_video1[raw_videoindex].minutestring;
        newraw_videoobj.by_system1 = raw_video1[raw_videoindex].by_system;
        newraw_videoobj.status1 = raw_video1[raw_videoindex].status;
        newraw_videoobj.video_url1 = raw_video1[raw_videoindex].video_url;
        newraw_videoobj.by_system2 = raw_video2[raw_videoindex].by_system;
        newraw_videoobj.status2 = raw_video2[raw_videoindex].status;
        newraw_videoobj.video_url2 = raw_video2[raw_videoindex].video_url;
        temprawvideolist.push(newraw_videoobj);
      }
      rawvideolist.current = temprawvideolist;
    } else {
      setrawvideodgopen(true);
    }
  };
  // eslint-disable-next-line camelcase
  const get_raw_video_api = async (datestr, channel) => {
    const Query = `raw-video/hour?vehicle=${selectrawVehicleplate.current.CAR_NO}&channel=${channel}&date=${datestr}&timezone_name=Asia/Taipei&hour=${rawhourobj.current}`;
    const url = `${host}api/DVR/gettheomnieyes_api?Query=${encodeURIComponent(Query)}`;
    await axios
      .get(
        url,
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      )
      .then(async (response) => {
        if (response.data.success) {
          response.data.results.forEach(element => {
            if (element.minute <= 9) {
              element.minutestring = `0${element.minute}`;
            } else {
              element.minutestring = element.minute;
            }
            if (channel == 1)
              raw_video1.push(element);
            else
              raw_video2.push(element);
          });

        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  }
  // eslint-disable-next-line camelcase
  const Vehicle_management = async () => {
    await axios
      .get(`${host}api/car/getcar?Region=${Region}`)
      .then(async (response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          // handle success
          // eslint-disable-next-line prefer-const
          let resArr = [];
          const set = new Set(response.data.data);
          resArr = Array.from(set);
          await setVehiclelist([]);

          // eslint-disable-next-line no-plusplus
          for (let arrayindex = 0; arrayindex < resArr.length; arrayindex++) {
            resArr[arrayindex].label = resArr[arrayindex].CAR_NO;
            resArr[arrayindex].title = resArr[arrayindex].CAR_NO;
          }
          await setVehiclelist(resArr);
        } else {
          setreason(response.data.message);
          setVehiclelist([]);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  const tabledateToStrTime = (datetime1, mode) => {
    // eslint-disable-next-line no-var
    var datetime = new Date(datetime1);
    let returnstr = '';
    // eslint-disable-next-line no-var
    var year = datetime.getFullYear();
    // eslint-disable-next-line no-var
    var month = datetime.getMonth() + 1;// js從0開始取
    // eslint-disable-next-line no-var
    var date = datetime.getDate();
    // eslint-disable-next-line no-var
    var hour = datetime.getHours();
    // eslint-disable-next-line no-var
    var minutes = datetime.getMinutes();
    // eslint-disable-next-line no-var
    var second = datetime.getSeconds();

    if (month < 10) {
      month = `0${month}`;
    }
    if (date < 10) {
      date = `0${date}`;
    }
    if (hour < 10) {
      hour = `0${hour}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (second < 10) {
      second = `0${second}`;
    }
    // eslint-disable-next-line eqeqeq
    if (mode == 0) {
      returnstr = `${year}-${month}-${date}`;
    } else {
      returnstr = `${hour}:${minutes}:${second}`;
    }
    return returnstr;
  };
  const dateTonetcoreStrTime = (datetime, mode) => {
    let returnstr = "";
    // eslint-disable-next-line eqeqeq
    if (mode == 0) {
      returnstr = datetimeobj.format(datetime, 'YYYY-MM-DD');
    } else {
      returnstr = datetimeobj.format(datetime, 'YYYY-MM-DD HH:mm:ss');

    }
    return returnstr;
  };
  const dateToStrTime = (datetime) => {
    const value = datetimeobj.format(datetime, 'YYYYMMDD');

    return value;
  };

  // re-usable method
  // eslint-disable-next-line no-extend-native
  Array.prototype.groupBy = function (prop) {
    // eslint-disable-next-line react/no-this-in-sfc
    return this.reduce((groups, item) => {
      const val = item[prop];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups;
    }, {});
  };
  // tab切換
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // 關閉彈跳釋出
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const eventButtonhandleClickOpen = (carobj) => {
    seteventButtonopen(true);
    seteventcarobj(carobj);
  };
  const eventButtonhandleClose = () => {
    seteventButtonopen(false);
  };
  const ButtonhandleClickOpen = (carid) => {
    setButtonopen(true);
    setcarno(carid);
  };

  const rawvideodgClose = () => {
    setrawvideodgopen(false);
  };
  const ButtonhandleClose = () => {
    setButtonopen(false);
  };
  const selecthandleChange = (event) => {
    sethourobj(event.target.value);
  };
  const videoButtonClick = async (videoobj, channel) => {
    if (channel == 1) {
      if (videoobj.status1 == null) {
        rawvideorrequest(videoobj, channel);
      } else if (videoobj.status1 == 5) {
        setvideourl(videoobj.video_url1);
      }
    }
    else {
      // eslint-disable-next-line no-lonely-if
      if (videoobj.status2 == null) {
        rawvideorrequest(videoobj, channel);
      } else if (videoobj.status2 == 5) {
        setvideourl(videoobj.video_url2);
      }

    }

  };
  const rawvideorrequest = async (videoobj, channel) => {
    // 向車機發出請求
    axios
      .get(
        `${host}api/DVR/rawvideorrequest?vehicle=${selectrawVehicleplate.current.CAR_NO}&datetime=${videoobj.video_datetime_tz}&channel=${channel}`,
        {
          headers: {
            'content-type': 'application/json'
          }
        }
      )
      .then((response) => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == 0) {
          // 發送需求成功執行一次搜尋
          get_raw_video();
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });


  };
  const handleToggle = (value) => () => {

    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    // eslint-disable-next-line eqeqeq
    if (value == 'all') {
      // eslint-disable-next-line no-lonely-if
      if (currentIndex === -1) {
        // eslint-disable-next-line prefer-arrow-callback
        event_message.forEach(function (messageobj) {
          newChecked.push(messageobj.event_type);
        });

      } else {
        newChecked.length = 0;
      }


    } else {
      // eslint-disable-next-line no-lonely-if
      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
    }


    setChecked(newChecked);
  };
  return (
    <Page title="座艙全時紀錄 | 智慧城市移動資訊平台">
      <Container maxWidth="xl">
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            {reason}
          </Alert>
        </Snackbar>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="即時監控" {...a11yProps(0)} />
          <Tab label="DVR事件查詢" {...a11yProps(1)} />
          <Tab label="原始影像調閱" {...a11yProps(2)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <></>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <></>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <></>
        </TabPanel>
      </Container>
      <EventDialog
        eventcarobj={eventcarobj}
        Buttonopen={eventButtonopen}
        ButtonhandleClose={eventButtonhandleClose}
        setreason={setreason}
      />
      <BootpDialog
        carno={carno}
        Buttonopen={Buttonopen}
        ButtonhandleClose={ButtonhandleClose}
        setreason={setreason}
      />
      <Dialog
        open={rawvideodgopen}
        onClose={rawvideodgClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          尚未選擇車牌或時間
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            請選擇車牌或時間
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={rawvideodgClose}>關閉</Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
